<template>
  <dialog-base show-close
               @close="close">
    <div class="mod-award">
      <div class="box-header">
        <div v-for="(item, index) in tab.list"
             :key="index"
             :class="{active: tab.current === index}"
             class="tab-item"
             @click="tapTab(index)">
             <span>{{item}}</span>
             </div>
      </div>
      <div class="box-body">
        <div v-if="tab.current === 0"
             class="wealth">
          <div class="list">
            <div class="ico-chest-set">
            </div>
          </div>
          <div class="tip">宝物们可能会躲在广告牌、树木、餐桌上噢～</div>
        </div>
        <div v-else
             class="award">
          <div class="list">
            <template v-if="!isQuery">
              <div v-if="!award.list.length"
                   class="award-tip">
                你还没有红包，加油寻宝物获得抽奖机会吧
              </div>
              <div v-else
                   v-for="(item, index) in award.list"
                   :key="'award' + index"
                   class="award-item">
                <span class="primary">{{item.prize_price}}</span>元红包
              </div>
            </template>
          </div>
          <div class="tip">
            中奖的微信红包会在24小时内直接存入微信零钱，
            若参与人数过多，可能会出现派发延误，请耐心等待。
          </div>
        </div>
      </div>
    </div>
  </dialog-base>
</template>

<script>
/**
 * 财富锦囊
 */
import { apiTreasureHuntUserPrize } from '@/api/treasure-hunt'
import DialogBase from '../base'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  components: {
    DialogBase
  },
  data() {
    return {
      tab: {
        list: ['寻宝任务', '我的奖品'],
        current: 0
      },
      isQuery: false,
      award: {
        list: []
      }
    }
  },
  methods: {
    async getAward() {
      this.$loading()
      this.isQuery = true
      try {
        const { data: { data } } = await apiTreasureHuntUserPrize()
        this.award.list = data
        this.$toast.clear()
      } catch (error) {
        this.$toast.clear()
        this.$toast(error.message)
      }
      this.isQuery = false
    },
    tapTab(index) {
      if (this.tab.current === index) return
      this.tab.current = index
      if (index === 1) {
        this.getAward()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-award {
  width: 644px;
  .box-header {
    padding: 0 67px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tab-item {
      margin-bottom: -4px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 249px;
      height: 87px;
      font-size: 38px;
      font-weight: bold;
      color: #fdf2e5;
      // color: #000;
      background: #ea5404;
      border: 4px solid #882104;
      border-bottom-width: 0;
      border-radius: 30px 30px 0px 0px;
      z-index: 1;
      &.active {
        color: #ea5404;
        background: #fdf2e5;
        z-index: 20;
      }
    }
  }
  .box-body {
    position: relative;
    font-size: 28px;
    color: #f57906;
    background: #fdf2e5;
    border: 4px solid #882104;
    border-radius: 30px;
    z-index: 10;
    .wealth {
      padding: 60px 38px 38px;
      .list {
        display: flex;
        align-items: center;
        justify-content: center;
        .ico-chest-set {
          width: 444px;
          height: 528px;
          background-image: url("../../../assets/ico/ico-chest-set.png");
          background-size: 100% auto;
          background-repeat: no-repeat;
        }
      }
      .tip {
        margin-top: 39px;
        text-align: center;
        font-size: 28px;
        color: #f57906;
      }
    }
    .award {
      padding: 48px;
      min-height: 681px;
      .list {
        min-height: 436px;
        .award-item {
          margin: auto;
          padding-left: 35px;
          width: 389px;
          height: 116px;
          display: flex;
          align-items: center;
          background-image: url("~@/assets/ico/ico-redenvelope-bg.png");
          background-size: 100% auto;
          background-repeat: no-repeat;
          color: #fff;
          font-size: 30px;
          text-shadow: 0px -1px 0 #882104, 1px 0px 0 #882104, 0px 1px 0 #882104,
            -1px 0px 0 #882104;
          &:nth-child(n + 2) {
            margin-top: 24px;
          }
          .primary {
            font-size: 53px;
          }
        }
      }
      .tip {
        font-size: 28px;
        color: #f57906;
      }
    }
  }
}
</style>